// extracted by mini-css-extract-plugin
export default {"Virtual":"Virtual_Virtual__JyUCO","left":"Virtual_left__TCY3M","wrapper":"Virtual_wrapper__Lhjd1"};